import React from 'react';
import styled from 'styled-components';
import Icon from '@spark/ui-components/components/Icon';
import Tooltip from '@spark/ui-components/components/Tooltip';

export const JANELA_DESCARGA_HINT = 'Considera a janela de descarga de cada loja';

const JanelaDescargaHint = ({ text = JANELA_DESCARGA_HINT }) => (
  <Tooltip dir="top" text={text}>
    <HintIcon role="img" aria-label={text} tabIndex={0}>
      <Icon name="information-outline" size={14} />
    </HintIcon>
  </Tooltip>
);

export const CardTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;

  h5 {
    margin-bottom: 0;
  }
`;

const HintIcon = styled.span`
  display: inline-flex;
  align-items: center;
  color: #6b7280;
  cursor: help;
`;

export default JanelaDescargaHint;
